import { render, staticRenderFns } from "./new.vue?vue&type=template&id=61b0cfa2&lang=pug&"
import script from "./new.vue?vue&type=script&setup=true&lang=js&"
export * from "./new.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports